import {
  ActivitySettings,
  DiagramGeneralSettings,
  FlowlineSettings,
  PositionType,
  ResourceSettings,
  RichTextSettings
} from '../diagram-type-styles.model';
import {ARCHITECTURE} from '../../../shared/constants/diagram-subtypes.constants';
import {DiagramBaseConfig} from './diagram-base-config';
import {FlowlineForm} from '../flowline-form.enum';

declare const mxGeometry: any;
declare const mxPoint: any;

export class ArchitectureBaseConfig extends DiagramBaseConfig {
  generalSettings(): DiagramGeneralSettings {
    return {
      canAddToLegend: true,
      canAutoGenerateDrilldown: false,
      canAddAttribute: true,
      canGenerateStoriesAI: false,
      canGenerateRequirements: true,
      addSFAHeader: true,
      zoomToFitNeeded: true,
      isLabelMovable: false,
      tagColor: '#465a72',
      allowedDrilldownSubtypes: []
    };
  }

  readonly activityShape = {w: 180, h: 60};

  activitySettings(x?: number, y?: number): ActivitySettings {
    const defaultActivityShape = this.activityShape;

    return {
      text: ARCHITECTURE.ACTIVITY_TEXT,
      position: this.getPosition(defaultActivityShape, x, y, PositionType.CENTER),
      dragHandlePosition: this.getPosition(defaultActivityShape, x, y, PositionType.DEFAULT),
      footerText: '',
      canPlaceFrontBack: true,
      canAddFooterText: true,
      canMakeContainerCard: true,
      selectedTabIndex: 4,
      defaultActivityShape,
      calcAddHeight: this.calculateAdditionalHeight,
      createActivityWithFlowline: false,
      template:
        '<input type="hidden" name="number" value="{{number}}"><!--contentbegin-->{{content}}<!--contentend-->'
    };
  }

  flowlineSettings(x?: number, y?: number, id?: number | string): FlowlineSettings {
    const defaultFlowlineShape = {w: 70, h: 0};

    return {
      dynamicLabel: ARCHITECTURE.FLOWLINE_TEXT,
      canAddStartText: true,
      canAddEndText: true,
      canAddInteraction: true,
      defaultFlowlineShape,
      config: {
        text: '',
        srcType: 'none',
        tgtType: 'none',
        waypoints: null,
        srcPosition: {
          x: x - 70,
          y: y + 40
        },
        tgtPosition: {
          x: x + 70,
          y
        },
        position: {
          connectionPoints: {
            entryX: 0,
            entryY: 0.5
          },
          offset: {x: 0, y: 0},
          x: 0,
          y: 15
        },
        srcId: null,
        tgtId: Number(id)
      },
      geo: () => {
        const geo = new mxGeometry(0, 0);

        geo.relative = true;
        geo.offset = new mxPoint(-15, -5);

        return geo;
      },
      template: '<div class="flowline-content">{{content}}</div>',
      form: {
        shape: FlowlineForm.shape.Orthogonal,
        type: FlowlineForm.type.Solid,
        start: FlowlineForm.end.None,
        end: FlowlineForm.end.None
      }
    };
  }

  resourceSettings(): ResourceSettings {
    return {
      size: 40,
      height: 40,
      resourcePlacement: true
    };
  }

  get richTextSettings(): RichTextSettings {
    const defaultTextShape = {w: 120, h: 80};

    return {
      defaultTextShape,
      template:
        '<input type="hidden" name="number" value="{{number}}"><div class="text-shape-content">{{content}}</div>',
      preparePayload: ({x, y, number, style, position}) => ({
        number,
        text: 'Text',
        position: this.getPosition(defaultTextShape, x, y, position),
        link: '',
        customStyle: true,
        style
      })
    };
  }
}
